export const members2k22 = [
  {
    name: "Amit",
    post: "Captain",
    linkedinLink:
      "https://www.linkedin.com/in/amit-a0997924a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "./images/members2k22/Amit.jpg",
  },
  {
    name: "Ritesh Kumar Bharti ",
    post: "Vice Captain",
    linkedinLink:
      "https://www.linkedin.com/in/ritesh-kumar-bharti-5701a6253?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BqY%2B2E9%2FsSTy2fKOXnR%2FI1Q%3D%3D",
    img: "./images/members2k22/Ritesh kumar Bharti.jpeg",
  },
  {
    name: "Rathlavath Lokesh",
    post: "Team Manager",
    linkedinLink:
      "https://www.linkedin.com/in/rathlavath-lokesh-5b32bb268?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "./images/members2k22/Rathlavath.jpg",
  },
 
 
 
  {
    name: "Anjeet Singh ",
    post: "Web Head",
    linkedinLink:
      "https://www.linkedin.com/in/anjeet-singh-51716225b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BVZ0c%2BGmnTOeK8HY84MywPQ%3D%3D",
    img: "./images/members2k22/Anjeet Singh.jpeg",
  }, {
    name: "Shubham kumar sinha",
    post: "Web Head",
    linkedinLink:
      "https://www.linkedin.com/in/shubham-kumar-sinha-137a68257?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BTkpAfXTJR4%2B6lCSquTH%2BXA%3D%3D",
    img: "./images/members2k22/Shubham kumar sinha.jpeg",
  },
  {
    name: " Abhishek Bhoutkar",
    post: "Sponsorship Head",
    linkedinLink:
      "https://www.linkedin.com/in/abhishek-bhoutkar-ba9684289?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BGeU%2Fnkv7T7Wlx3jTVZj8TQ%3D%3D",
    img: "./images/members2k22/Bhoutkar.jpg",
  },
  {
    name: "Sampriti chatterjee",
    post: "Technical Head",
    linkedinLink:
      "https://www.linkedin.com/in/sampriti-chatterjee-24a23a270?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BzHns332LTHe1n4qNRbTaww%3D%3D",
    img: "./images/members2k22/sampriti chatterje.jpeg.jpg",
  },
  {
    name: "Sohan bhowmick",
    post: "Technical Head",
    linkedinLink:
      "https://www.linkedin.com/in/sohan-bhowmick-3225b0249?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BXC7kH8pVSo%2BK6B0nPAfNwg%3D%3D",
    img: "./images/members2k22/Sohan bhowmick.jpeg",
  },
  {
    name: "Ajay Prajapati",
    post: "Manufacturing Head",
    linkedinLink:
      "https://www.linkedin.com/in/ajay-prajapati-62a56727b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "./images/members2k22/Ajay.jpeg",
  },
  {
    name: "Priyanshi",
    post: "Manufacturing Head",
    linkedinLink:
      "https://www.linkedin.com/in/priyanshi-9a70a225b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BDs8z5q2yR%2FG0M4AIPiIAKw%3D%3D",
    img: "./images/members2k22/priyanshi.jpeg.jpg",
  },
  {
    name: " Priyanshu Kumar",
    post: "Electrical Head",
    linkedinLink:
      "https://www.linkedin.com/in/priyanshu-kumar-4ab546244?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BgZ%2BzZe%2FgS2SIl330B9aLUA%3D%3D",
    img: "./images/members2k22/Priyanshu Kumar.jpeg",
  },
  {
    name: "Aditya raj",
    post: "Electrical Head",
    linkedinLink:
      "https://www.linkedin.com/in/aditya-raj-5b5bb9272?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B0Kx%2BRnjuQAaMu2kDOi8MzQ%3D%3D",
    img: "./images/members2k22/Aditya raj.jpeg",
  },
  {
    name: "Vedha Sharma ",
    post: "B-Plan Head",
    linkedinLink:
      "https://www.linkedin.com/in/vedha-sharma-985768271?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BXmnIGwI6SiC6REB6HoY1xg%3D%3D",
    // img: "https://www.vhv.rs/dpng/d/15-155087_dummy-image-of-user-hd-png-download.png",
    img: "./images/members2k22/VedhaSharma.JPG",
  },
  {
    name: "Abhinav Nishith",
    post: "Innovation Head",
    linkedinLink:
      "https://www.linkedin.com/in/abhinav-nishith-63b332206?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "./images/members2k22/Abhinav.jpg",
  },
 
  {
    name: "Prakhar Pragya",
    post: "PR Head",
    linkedinLink:
      "https://www.linkedin.com/in/prakhar-pragya-6073322a7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "./images/members2k22/Prakhar.jpg",
  },
  {
    name: "Sourya Dey",
    post: "Finance Head",
    linkedinLink:
      "https://www.linkedin.com/in/sourya-dey-4b27961b6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    img: "./images/members2k22/Sourya.jpg",
  },
  

  // {
  //   name: "Suman maity",
  //   post: "member",
  //   linkedinLink:
  //     "https://www.linkedin.com/in/suman-maity-b093b1253?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BODSjUggTR2KESHdAVaYkaw%3D%3D",
  //   img: "./images/members2k22/Suman maity.jpeg",
  // },
 
  // {
  //   name: "Mayank raj ",
  //   post: "member",
  //   linkedinLink:
  //     "https://www.linkedin.com/in/mayank-raj-1858b3288?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BLEz7WDkPRimsVNqzQPILkg%3D%3D",
  //   img: "./images/members2k22/Mayank raj.jpeg",
  // },
  {
    name: " Prashant kumar",
    post: "Creative Head",
    linkedinLink:
      "https://www.linkedin.com/in/prashant-kumar-357879289?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BNgi8jBapTFq%2BEnRHUB1jFw%3D%3D",
    img: "./images/members2k22/Prashant kumar.jpeg",
  },
  {
    name: "Priyanshu kumar",
    post: "Breaking Head",
    linkedinLink:
      "https://www.linkedin.com/in/priyanshu-kumar-11b479289?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BQxjH3K07Sjed0tRSDK2XfQ%3D%3D",
    img: "./images/members2k22/priyanshu kumar(ME).jpeg",
  },
  {
    name: "Swadhinta Verma",
    post: "Content Head",
    linkedinLink: "https://www.linkedin.com/in/swadhinta-verma-8213582a7/",
    img: "./images/members2k22/Swadhinta.jpeg",
  },
  {
    name: "Shreya kumari ",
    post: "Transmission Head",
    linkedinLink:
      "https://www.linkedin.com/in/shreya-kumari-147869271?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B9BoO17UIR%2BSeXJ%2BFcivx7Q%3D%3D",
    img: "./images/members2k22/sherya kumari.jpeg.jpg",
  },
  
  {
    name: "Jogindra Nath",
    post: "Suspension Head",
    linkedinLink:
      "https://www.linkedin.com/in/jogindra-nath-gond-b3b461258?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "./images/members2k22/Jogindra.jpg",
  },
 
  // {
  //   name: "Khushi",
  //   post: "member",
  //   linkedinLink:
  //     "https://www.linkedin.com/in/khushi-585ba327b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BNH30o5S4SbOpvhqym33sUA%3D%3D",
  //   img: "./images/members2k22/khushi.jpeg",
  // },

 
  // {
  //   name: "Priyanshu dev",
  //   post: "member",
  //   linkedinLink:
  //     "https://www.linkedin.com/in/priyanshu-dev-9671b2252?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BRogmjVqMROefP3RuW8hjlg%3D%3D",
  //   img: "./images/members2k22/Priyanshu dev.jpeg",
  // },

   
  {
    name: "Rajnish ranjan soren ",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/rajnish-ranjan-soren-37278b168?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bu%2FdAurx1T2eviC%2F67IXemQ%3D%3D",
    img: "./images/members2k22/Rajnish ranjan soren.jpeg",
  },

  {
    name: "Utkarsh shukla ",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/utkarsh-shukla-bb1a01257?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B2cUWLEkmT7W35nH6IodrPg%3D%3D",
    img: "./images/members2k22/Utkarsh Shukla.jpeg",
  },
  {
    name: "Satya Narayan Lal ",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/satya-narayan-lal-a8a284251?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bna%2B4XGsuRVixflSFcj9wXA%3D%3D",
    img: "./images/members2k22/satya narayan lal.jpeg.jpg",
  },
 
 

  {
    name: "Ankita Prasad",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/ankita-prasad-77270a271?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "./images/members2k22/Ankita.jpg",
  },

 
  { 
    name: "Shivam kumar ",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/shivam-kumar-853752257?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bvy2ku9WNTKG%2FbndUeh1HhQ%3D%3D",
    img: "./images/members2k22/Shivam Kumar.jpeg",
  },
   
  {
    name: "Raju Sen",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/raju-sen-555592270?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "./images/members2k22/Raju.jpg",
  },
  {
    name: " Kumar Amarjeet",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/amarjeet-kumar-606955202?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B7GKKA5rqRCaF4sa%2Fx%2FMKqA%3D%3D",
    img: "./images/members2k22/Amarjeet.jpg",
  },
  {
    name: " Simran Gupta",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/simran-gupta-543a4b25a?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BJ5VhLHwgRh2dQpz5%2FhT6sQ%3D%3D",
    img: "./images/members2k22/Simran Gupta.jpeg",
  },
  {
    name: "Abhiram gattamneni",
    post: "Member",
    linkedinLink:
      "https://www.linkedin.com/in/abhiram-gattamneni-309183258?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BtV2eG2E4Q1%2BYYXP5HGpJuw%3D%3D",
    img: "./images/members2k22/Abhiram gattamneni.jpeg",
  },
  // 2k22 member's
];
export const members2k21 = [
  {
    name: "Priyanshu Raj",
    post: "Captain",
    linkedinLink:
      "https://www.linkedin.com/in/priyanshu-raj-7049a522b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/Priyanshu.jpg",
  },
  {
    name: "Ayushi Kumari",
    post: "Vice Captain",
    linkedinLink:
      "https://www.linkedin.com/in/ayushi-kumari-366540246?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/Ayushi.jpg",
  },
  {
    name: "Aditya Pal",
    post: "Team Manager",
    linkedinLink:
      "https://www.linkedin.com/in/aditya-pal-1a0026229?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/Aditya.jpg",
  },
  {
    name: "Bittu Thakur",
    post: "Web Head",
    linkedinLink:
      "https://www.linkedin.com/in/bittu-thakur-618774211?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/BittuThakur.jpeg",
  },
  {
    name: "Shaket Shubham",
    post: "Web Head",
    linkedinLink:
      "https://www.linkedin.com/in/shaket-shubham-7939b6214?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/ShaketShubham.jpeg",
  },

  {
    name: "Shashant Kumar",
    post: "Technical Head",
    linkedinLink:
      "https://www.linkedin.com/in/shashant-kumar-215031256?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/ShashantKumar.jpeg",
  },

  {
    name: "Narne Srinadh",
    post: "Finance Head",
    linkedinLink:
      "https://www.linkedin.com/in/srinadhnarne?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/NarneSrinadh.jpeg",
  },
  {
    name: "David Hussa Purty",
    post: "Innovation Head",
    linkedinLink:
      "https://www.linkedin.com/in/david-hassa-purty-a48b1722b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/DavidHussaPurty.jpeg",
  },
  {
    name: "Sourjayani Sarkar",
    post: "B-Plan Head",
    linkedinLink:
      "https://www.linkedin.com/in/sourjayani-sarkar-a78202247?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/SourjayaniSarkar.jpeg",
  },
  {
    name: "Raj Sharma",
    post: "Associate B-Plan Head",
    linkedinLink:
      "https://www.linkedin.com/in/raj-s-7a313b222?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/RajS.jpeg",
  },
  {
    name: "Anwesha Ghosh",
    post: "Electrical Head",
    linkedinLink:
      "https://www.linkedin.com/in/anwesha-ghosh-8a57bb222?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/AnweshaGhosh.png",
  },
  {
    name: "Simmi Kedia",
    post: "Electrical Head",
    linkedinLink:
      "https://www.linkedin.com/in/simmi-kedia-7a2a8b230?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/SimmiKedia.jpeg",
  },
  {
    name: "Aditya Sonkar",
    post: "PR Head / Associate Electrical Head",
    linkedinLink:
      "https://www.linkedin.com/in/aditya-sonkar-363b2423a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/AdityaSonkar.jpeg",
  },
  {
    name: "Ayush Nitin",
    post: "Manufacturing Head / Sponsorship Head",
    linkedinLink:
      "https://www.linkedin.com/in/aayush-nitin-a86856227?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/AyushNitin.jpeg",
  },
  {
    name: "Anubhav",
    post: "Creative Head",
    linkedinLink:
      "https://www.linkedin.com/in/anubhav-kumar-67987a254?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/Anubhav.jpeg",
  },
  {
    name: "Shiv Shankar",
    post: "Content Head",
    linkedinLink:
      "https://www.linkedin.com/in/shiv-shankar-kumar-7a8aa527a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/Shivshankar.jpeg",
  },
  {
    name: "Harsh Tiwary",
    post: "Sponsorship Head",
    linkedinLink:
      "https://www.linkedin.com/in/harsh-tiwary-431534224?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/HarshTiwary.jpeg",
  },
  {
    name: "Aman Kumar",
    post: "Suspension Head",
    linkedinLink:
      "https://www.linkedin.com/in/aman-kumar-629591230?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/AmanKumar.jpeg",
  },
  {
    name: "Rajni",
    post: "Breaking Head",
    linkedinLink:
      "https://www.linkedin.com/in/rajni9031?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/RajniSingh.jpeg",
  },
  {
    name: "Rohit Sharma",
    post: "Fabrication Head",
    linkedinLink:
      "https://www.linkedin.com/in/rohit-sharma-563038219?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/RohitSharma.jpg",
  },
  {
    name: "Tamalika Halder",
    post: "Steering Head",
    linkedinLink:
      "https://www.linkedin.com/in/tamalika-halder-9a06b424b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    img: "images/members2k21/TamalikaHalder.jpeg",
  },
  // Add more member objects as needed
];
export const members2k20 = [
  {
    name: "Rajat Raj",
    post: "Captain",
    linkedinLink: "https://www.linkedin.com/in/rajat-raj17/",
    img: "./images/members2k20/rajat.jpeg",
  },
  {
    name: "Prabhat Kumar",
    post: "Team Manager",
    linkedinLink: "https://www.linkedin.com/in/prabhat-kumar-89aa67202/",
    img: "./images/members2k20/prabhat_kumar.jpeg",
  },
  {
    name: "Aditya Jha",
    post: "Vice Captain",
    linkedinLink: "https://www.linkedin.com/in/aditya-jha-b3bab0229/",
    img: "./images/members2k20/aditya_jha.jpeg",
  },

  {
    name: "Kumar Sankalp",
    post: "Electrical Head",
    linkedinLink: "https://www.linkedin.com/in/kumar-sankalp-425b951a2/",
    img: "./images/members2k20/kumar_sankalp.jpeg",
  },

  {
    name: "Bhavya Kumari",
    post: "Associate Electrical Head",
    linkedinLink: "https://www.linkedin.com/in/bhavya-kumari-550808223/",
    img: "./images/members2k20/bhavya_kumaris.jpeg",
  },

  {
    name: "Suman K. Manjhi",
    post: "Innovation Head",
    linkedinLink: "https://www.linkedin.com/in/suman-kumar-manjhi-1537a622a/",
    img: "./images/members2k20/suman_manjhi.jpeg",
  },

  {
    name: "Shivani Tupe",
    post: "B-Plan Head",
    linkedinLink: "https://www.linkedin.com/in/shivani-tupe-52b055219/",
    img: "./images/members2k20/shivani_tupe.jpeg",
  },

  {
    name: "Jatavath Bharat",
    post: "Manufacturing Head",
    linkedinLink: "https://www.linkedin.com/in/bharath-jatavath-2976a622a/",
    img: "./images/members2k20/jatavath_bharat.jpeg",
  },

  {
    name: "Vivek K. Gupta",
    post: "Content Head",
    linkedinLink: "https://www.linkedin.com/in/vivek-kumargupta/",
    img: "./images/members2k20/VivekKumarGupta (1).jpeg",
  },

  {
    name: "Shams Tabrez",
    post: "Creative Head",
    linkedinLink: "https://www.linkedin.com/in/shams-tabrez-1bb92a143/",
    img: "./images/members2k20/shams_tabrej.jpeg",
  },
  {
    name: "Sanjeev P. Verma",
    post: "Technical and Design Head",
    linkedinLink: "https://www.linkedin.com/in/sanjeev-pratap-verma-156987213/",
    img: "./images/members2k20/SanjeevVerma.jpg",
  },
  {
    name: "Anushka",
    post: "PR Head",
    linkedinLink: "https://www.linkedin.com/in/anushka-0bb29b216/",
    img: "./images/members2k20/Anushka.jpg",
  },
  {
    name: "Hemanth Venkat",
    post: "Manufacturing Head",
    linkedinLink: "",
    img: "./images/members2k20/Venkat.jpg",
  },
  {
    name: "Anshu Kumari",
    post: "PR Head",
    linkedinLink: "",
    img: "./images/members2k20/Anshu.jpg",
  },
  // Add more member objects as needed
];
export const members2k19 = [
  {
    name: "Abhisekh Kumar",
    post: "Captain",
    linkedinLink: "https://www.linkedin.com/in/abhishek2722/",
    img: "./images/members2k19/abhishek kumar_captain.jpeg",
  },
  {
    name: "Amritansh Tiwari",
    post: "Vice Captain",
    linkedinLink: "https://www.linkedin.com/in/amritansh-t-805298b8/",
    img: "./images/members2k19/Amritansh Tiwari_vice captain.jpeg",
  },

  {
    name: "Keerti Sharma",
    post: "Team P&D & Manager",
    linkedinLink: "https://www.linkedin.com/in/keerti-sharma-a866761b0/",
    img: "./images/members2k19/Keerti Sharma_P&D  Manager.jpeg",
  },

  {
    name: "Abhishek Kumar",
    post: "Manufacturing Head",
    linkedinLink: "https://www.linkedin.com/in/abhishek-kumar-2a66041a6/",
    img: "./images/members2k19/Abhishek Kumar_Manufacturing Head.jpeg",
  },

  {
    name: "Shashank Shekhar",
    post: "Web Head",
    linkedinLink: "https://www.linkedin.com/in/shashank-shekhar-bb19671a3/",
    img: "./images/members2k19/Shashank Shekhar_web_head.jpeg",
  },

  {
    name: "Nilanjan Sengupta",
    post: "Creative Head, Treasurer",
    linkedinLink: "https://www.linkedin.com/in/nilanjan-sengupta-2529241b2/",
    img: "./images/members2k19/Nilanjan Sengupta_Creative Head, Treasurer.jpeg",
  },
  {
    name: "Alok Kumar Singh",
    post: "Innovation and R&D Head",
    linkedinLink: "https://www.linkedin.com/in/alok-kumar-singh-7530171bb/",
    img: "./images/members2k19/alok kumar_Innovation and R&D Head.jpeg",
  },
  {
    name: "Akash Kumar Sen",
    post: "Innovation and R&D Head",
    linkedinLink: "https://www.linkedin.com/in/akash-kumar-sen-8ba721280/",
    img: "./images/members2k19/Akash Kumar Sen_Innovation and R&D Head.jpeg",
  },
  {
    name: "Adarsh keshari",
    post: "Electrical Head",
    linkedinLink: "https://www.linkedin.com/in/akeshari44/",
    img: "./images/members2k19/Adarsh keshari_Electrical Head.jpeg",
  },
  {
    name: "Shreyansh yadav",
    post: "Technical head",
    linkedinLink: "https://www.linkedin.com/in/shreyansh-yadav28/",
    img: "./images/members2k19/Shreyansh yadav_Technical head.jpeg",
  },
  {
    name: "Amman Akthar",
    post: "Corporate Affairs Head",
    linkedinLink: "https://www.linkedin.com/in/amman-akhtar-b875561b8/",
    img: "./images/members2k19/Amman Akthar_Corporate Affairs Head.jpeg",
  },

  {
    name: "Ekta Dhanuka",
    post: "PR Head",
    linkedinLink: "https://www.linkedin.com/in/ekta-dhanuka-a320931b6/",
    img: "./images/members2k19/Ekta Dhanuka_PR Head.jpeg",
  },
  {
    name: "Ishika Kumari",
    post: "PR Head",
    linkedinLink: "https://www.linkedin.com/in/ishika-k/",
    img: "./images/members2k19/Ishika Kumari_PR Head.jpeg",
  },
  {
    name: "Twinkle kumar",
    post: "Mechanical Head",
    linkedinLink: "https://www.linkedin.com/in/twinkle-kumar-93758523a/",
    img: "./images/members2k19/Twinkle kumar_Mechanical Head.jpeg",
  },

  {
    name: "Kriti Jha",
    post: "Team Representative",
    linkedinLink: "https://www.linkedin.com/in/kriti-jha-0511951b5/",
    img: "./images/members2k19/Kriti Jha_Team Representative.jpeg",
  },

  {
    name: "Nisit Tripathi",
    post: "Braking Head",
    linkedinLink: "https://www.linkedin.com/in/nisit-tripathi/",
    img: "./images/members2k19/Nisit Tripathi_Braking Head.jpeg",
  },
  {
    name: "Santosh Paul",
    post: "Suspension & Design Head",
    linkedinLink: "https://www.linkedin.com/in/santosh-paul-a152931a1/",
    img: "./images/members2k19/Santosh Paul_Suspension & Design Head.jpeg",
  },
  {
    name: "Sushant Kumar",
    post: "General Manager",
    linkedinLink: "https://www.linkedin.com/in/sushant-kumar-6b0978192/",
    img: "./images/members2k19/SushantKumar (1).jpeg",
  },
  {
    name: "Abhishek Pandey",
    post: "Steering Head",
    linkedinLink: "https://www.linkedin.com/in/abhishek-pandey-2b40211b1/",
    img: "./images/members2k19/Abhishek Pandey_Steering Head.jpeg",
  },
  {
    name: "Jasmeet Kaur",
    post: "Corporate Affairs Head",
    linkedinLink: "https://www.linkedin.com/in/jasmeet-kaur-a178191a0/",
    img: "https://www.vhv.rs/dpng/d/15-155087_dummy-image-of-user-hd-png-download.png",
  },

  {
    name: "Trisha Tanushree",
    post: "Team Representative",
    linkedinLink: "https://www.linkedin.com/in/trisha-tanushree-319b58199/",
    img: "./images/members2k19/Trisha Tanushree_Team Representative.jpeg",
  },
  {
    name: "Harshit Alok",
    post: "Administrative Head",
    linkedinLink: "https://www.linkedin.com/in/harshit-alok-a988411ab/",
    img: "https://www.vhv.rs/dpng/d/15-155087_dummy-image-of-user-hd-png-download.png",
  },
  {
    name: "Vemulapalli Jagadeesh",
    post: "Technical Inspector",
    linkedinLink:
      "https://www.linkedin.com/in/vemulapalli-jagadeesh-3142881a7/",
    img: "./images/members2k19/Vemulapalli Jagadeesh_Technical Inspector.jpeg",
  },

  // Add more member objects as needed
];
const batches = [
  {
    name: "Student 1",
    imageUrl:
      "https://cdn.pixabay.com/photo/2018/01/17/07/06/laptop-3087585_640.jpg",
  },
  {
    name: "Student 2",
    imageUrl:
      "https://cdn.pixabay.com/photo/2018/01/17/07/06/laptop-3087585_640.jpg",
  },
  {
    name: "Student 3",
    imageUrl:
      "https://cdn.pixabay.com/photo/2018/01/17/07/06/laptop-3087585_640.jpg",
  },
  // Add more objects with names and image URLs as needed
];
export default batches;
